import { render, staticRenderFns } from "./book_order.vue?vue&type=template&id=ac2f78b4"
import script from "./book_order.vue?vue&type=script&lang=js"
export * from "./book_order.vue?vue&type=script&lang=js"
import style0 from "./book_order.vue?vue&type=style&index=0&id=ac2f78b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports